import React, { useContext } from "react";
import { Box, Snackbar, Alert } from "@mui/material";
import HeaderAppBar from "./HeaderAppBar";
import SideDrawer from "./SideDrawer";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "../../pages/Home";
import Dashboard from "../../pages/Dashboard";
import Orders from "../../pages/Orders";
import Tickers from "../../pages/Tickers";
import ErrorPage from "../../pages/ErrorPage";
import GlobalContext from "../../contexts/globalcontext";
import AccountsBalance from "../../components/AccountsBalance";
import ThemeSample from "../../pages/ThemeSample";
import Bot from "../../pages/Bot";
import Users from "../../components/Users";

const MainLayout = () => {
    const { sbOpen, setSbOpen, sbMsg, sbSeverity } = useContext(GlobalContext);
    return (
        <>
            <Router>
                <Box>
                    <HeaderAppBar />
                    <Box sx={{ display: "flex" }}>
                        <SideDrawer />
                        <Box
                            sx={{
                                flexGrow: 1,
                                marginLeft: "20px",
                                marginTop: "80px",
                                marginRight: "10px",
                            }}
                        >
                            <Routes>
                                <Route exact path="/" element={<Home />} />
                                <Route
                                    exact
                                    path="/dashboard"
                                    element={<Dashboard />}
                                />
                                <Route
                                    exact
                                    path="/tickers"
                                    element={<Tickers />}
                                />
                                <Route
                                    exact
                                    path="/accounts"
                                    element={<AccountsBalance />}
                                />
                                <Route
                                    exact
                                    path="/accounts"
                                    element={<Tickers />}
                                />
                                <Route
                                    exact
                                    path="/orders"
                                    element={<Orders />}
                                />
                                <Route path="/bot" element={<Bot />} />
                                <Route
                                    path="/sample"
                                    element={<ThemeSample />}
                                />
                                <Route
                                    exact
                                    path="/users"
                                    element={<Users />}
                                />
                                <Route exact path="*" element={<ErrorPage />} />
                            </Routes>
                        </Box>
                    </Box>
                </Box>
                <Snackbar
                    open={sbOpen}
                    autoHideDuration={3000}
                    onClose={() => {
                        setSbOpen(false);
                    }}
                >
                    <Alert
                        icon={false}
                        variant="filled"
                        severity={sbSeverity}
                        sx={{ width: "100%", typography: "h4" }}
                    >
                        {sbMsg}
                    </Alert>
                </Snackbar>
            </Router>
        </>
    );
};

export default MainLayout;
